import { regionCodes } from "common/static/regions";

const YEAR_GROUPS_GB = [
  {
    value: 13,
    label: "Year 13"
  },
  {
    value: 12,
    label: "Year 12"
  },
  {
    value: 11,
    label: "Year 11"
  },
  {
    value: 10,
    label: "Year 10"
  },
  {
    value: 9,
    label: "Year 9"
  },
  {
    value: 8,
    label: "Year 8"
  },
  {
    value: 7,
    label: "Year 7"
  },
  {
    value: 6,
    label: "Year 6"
  },
  {
    value: 5,
    label: "Year 5"
  },
  {
    value: 4,
    label: "Year 4"
  },
  {
    value: 3,
    label: "Year 3"
  }
];

const YEAR_GROUPS_US = [
  {
    value: 13,
    label: "12th Grade"
  },
  {
    value: 12,
    label: "11th Grade"
  },
  {
    value: 11,
    label: "10th Grade"
  },
  {
    value: 10,
    label: "9th Grade"
  },
  {
    value: 9,
    label: "8th Grade"
  },
  {
    value: 8,
    label: "7th Grade"
  }
];

const YEAR_GROUPS_BR = [
  {
    value: 13,
    label: "Médio: 3o"
  },
  {
    value: 12,
    label: "Médio: 2o"
  },
  {
    value: 11,
    label: "Médio: 1o"
  },
  {
    value: 10,
    label: "Fundamental: 9o"
  },
  {
    value: 9,
    label: "Fundamental: 8o"
  },
  {
    value: 8,
    label: "Fundamental: 7o"
  },
  {
    value: 7,
    label: "Fundamental: 6o"
  },
  {
    value: 6,
    label: "Fundamental: 5o"
  }
];

const YEAR_GROUPS_FR = [
  {
    value: 13,
    label: "Terminale"
  },
  {
    value: 12,
    label: "Première"
  },
  {
    value: 11,
    label: "Seconde"
  },
  {
    value: 10,
    label: "Troisième"
  },
  {
    value: 9,
    label: "Quatrième"
  },
  {
    value: 8,
    label: "Cinquième"
  },
  {
    value: 7,
    label: "Sixième"
  }
];

export const YEAR_GROUPS = Object.freeze({
  [regionCodes.BR]: YEAR_GROUPS_BR,
  [regionCodes.FR]: YEAR_GROUPS_FR,
  [regionCodes.GB]: YEAR_GROUPS_GB,
  [regionCodes.US]: YEAR_GROUPS_US
});
